import React from "react";
import { Card } from "react-bootstrap";
import { NomuraLogo } from "pages/login/NomuraLogo";
import { AnalystGroup } from "./AnalystGroup";
import { _t } from "app/i18n/i18n";
import { DownloadExcelLink } from "./DownloadExcelLink";
import { DownloadAnalystImages } from "./DownloadAnalystImages";
import { toLocaleYYYYMMDD } from "lib/dateUtils";
import { useScrollToAnchor } from "lib/hooks/useScrollToAnchor";

export const AnalystListing = ({ group, specialities }) => {
  useScrollToAnchor();
  return (
    <Card className="bg-white px-3 text-dark mb-5 mb-0 border-1 shadow maxw-800">
      <AnalystLogoHeader />

      <Card.Body>
        {Object.entries(specialities).map(([speciality, analysts]) => (
          <AnalystGroup key={group + speciality} group={group} speciality={speciality} analysts={analysts} />
        ))}

        <DownloadExcelLink />
        <DownloadAnalystImages />
      </Card.Body>
    </Card>
  );
};

export const AnalystLogoHeader = () => (
  <Card.Header>
    <header className="d-flex flex-column align-items-end mb-0">
      <small className="d-block text-gray">{_t("Analyst Directory") + " " + year()}</small>
      <figure>
        <NomuraLogo className="mx-auto" styles={{ height: "50px", width: "150px" }} />
      </figure>
    </header>
  </Card.Header>
);

const year = () => toLocaleYYYYMMDD(new Date());
